<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="read 1">
      <g id="Group">
        <path id="Vector" d="M8.5 15.5V3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path
          id="Vector_2"
          d="M8.5 3.5L1.5 0.5V12.5L8.5 15.5L15.5 12.5V0.5L8.5 3.5Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>
